var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"documents-type-page main-box md:w-1/2 top-zero-radius"},_vm._l((_vm.tree),function(item,item_index){return _c('crud-tree',{key:item_index,attrs:{"tree":item,"options":_vm.treeOptions,"hide-options":true,"first":true,"first-hide":true}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }